import React from 'react';
import styles from '../styles/pages/Contact.module.css';
import { ContactForm } from '../components';

/**
 * Contact page component that displays the contact form
 * Uses custom ContactForm component with direct Formspree integration
 */
export function Contact() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Get In Touch</h1>
        <p className={styles.subtitle}>Have a question or want to work together? Send me a message!</p>
        <ContactForm />
      </div>
    </div>
  );
}

export default Contact;
